import indigo from '@material-ui/core/colors/indigo';

export default (theme) => ({
    root: {
        width: '100%',
    },
    tableRoot: {
        '& table > tfoot > tr > td.MuiTableCell-footer': {
            border: 'none'
        },
        [theme.breakpoints.up('md')]: {
            // table border
            '& > div[style]': {
                border: '2px solid #f5f5f5',
                borderBottomWidth: '1px',
                borderRadius: '4px',
            },

            // filters and search
            '& .MuiFormControl-root': {
                border: '1px solid rgba(0, 0, 0, 0.23)',
                borderRadius: '4px',
                padding: '4.5px 10.5px 3.5px',
                '& .MuiInputBase-root.MuiInput-root.MuiInput-underline:before': {display: 'none'},
                '& .MuiInputBase-root.MuiInput-root.MuiInput-underline:after': {display: 'none'},
            },

            '& .MuiToolbar-root.MuiToolbar-regular': {
                paddingRight: 0,
                marginBottom: '20px',

                '& .MuiFormControl-root.MuiTextField-root': {
                    width: '50%',
                },
            },
        },
    },
    container: {
        maxHeight: 440,
    },
    margin: {
        margin: theme.spacing(1),
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        '& > h2': {
            fontFamily: '"Montserrat", sans-serif',
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(5),
            [theme.breakpoints.down('xs')]: {
                marginTop: theme.spacing(3),
                marginBottom: theme.spacing(2.5),
            },
            flex: '1 1 auto',
        },
        '& > #add' : {
            color: '#fff',
            float: 'right',
            borderRadius: '50%',
            width: '24px',
            background: indigo[500],
            height: '24px',
        }
    },
    spanOpenDialogButton: {
        color: '#3f51b5',
        cursor: 'pointer',
        textDecoration: 'underline',
    },
    table: {
        width: '100%',
        marginBottom: theme.spacing(10),
    },
    modileGroupingRow: {
        '& tr.MuiTableRow-root': {
            '& td.MuiTableCell-root': {
                padding: '10px 15px',
            }
        },
        '& td.MuiTableCell-paddingCheckbox' : {
            display: 'none',
        },
        '& tr.MuiTableRow-root + div' : {
            '& tr.MuiTableRow-root': {
                '& td.MuiTableCell-root': {
                    padding: '10px 45px',
                }
            },
        },
        '& div + div' : {
            '& tr.MuiTableRow-root': {
                '& td.MuiTableCell-root': {
                    padding: '10px 45px',
                }
            },
        },
    },

    // product table only
    productTable_actions: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',

        '& .MuiSvgIcon-root': {
            '& + .MuiSvgIcon-root': {
                marginTop: 20,

                [theme.breakpoints.down('sm')]: {
                    marginTop: 0,
                    marginLeft: '20px !important',
                },
            },
        },

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'row',
            alignItems: 'center',
        },
    },

    // suppliers table

    ibanTable: {
        marginBottom: '15px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: '150px',

        [theme.breakpoints.down('sm')]: {
            maxWidth: 'unset',
        },
        [theme.breakpoints.down('xs')]: {
            maxWidth: '200px',
        },
        [theme.breakpoints.down(321)]: {
            maxWidth: '150px',
        },
    },
});
